import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { LectionaryItemTypeEditComponent } from '../lectionary-item-type-edit/lectionary-item-type-edit.component';
import { LectionaryItemType } from '../../services/lectionary-item-type.service';

@Component({
  selector: 'app-lectionary-item-type',
  templateUrl: './lectionary-item-type.component.html',
  styleUrls: ['./lectionary-item-type.component.css']
})
export class LectionaryItemTypeComponent implements OnInit {

  public entities: LectionaryItemType[];
  public isLoading = false;

  constructor(
    public dialog: MatDialog,
    private apiSvc: ApiService
  ) { }

  ngOnInit() {
    this.loadEntities();
  }

  private loadEntities() {
    this.isLoading = true;
    this.apiSvc.get("api/lectionaryitemtype", null).subscribe(
      (data: LectionaryItemType[]) => {
        this.entities = data;
        console.log(this.entities);

        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        console.log("error", err);
      }
    );
}

public add() {
  const dialogRef = this.dialog.open(LectionaryItemTypeEditComponent, {

    });
}

public edit(obj: LectionaryItemType) {

  var modal = this.dialog.open(LectionaryItemTypeEditComponent);
  modal.componentInstance.LoadItem(obj);

  modal.afterClosed().subscribe((savedItem: LectionaryItemType) => {

    console.log("modal closed", savedItem);

    if (savedItem !== undefined) {
      this.entities = null;
      this.loadEntities();
    }

  });

}

public delete(lang) {
   alert("Delete obj");
   console.log(lang);
}


}

